import styled from '@emotion/styled';
import { keyframes } from '@mui/material';
import { ReactNode } from 'react';

const blinkAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Blinker = styled('span')(({ color }) => ({
  animation: `${blinkAnimation} 1s infinite`,
  display: 'inline-block',
  color: color,
}));

type Props = {
  color?: string;
  children: ReactNode;
};

const BlinkingText = ({ color = 'inderit', children }: Props) => {
  return <Blinker color={color}>{children}</Blinker>;
};

export default BlinkingText;
